import { SimpleProductType } from 'api/repositories/SimpleProduct';
import { CODES } from './constants';

export const getProductData = ({
    attributes,
    availability,
    code,
    details,
    images,
    labels,
    minQuantity,
    name,
    price,
    slug,
    type,
    taxAmount,
}: SimpleProductType) => ({
    appUrl: details.appUrl,
    author: attributes.find(({ code }) => code === 'book_author')?.value,
    availability: availability.availableForSale,
    code: code,
    flipbook: details.flipbook,
    gallery: images.filter(({ type }) => type === CODES.GALLERY)[0].items,
    images,
    labels: labels,
    MEN: details.men,
    minQuantity,
    name,
    price,
    slug,
    thumbnail: images.filter(({ type }) => type === CODES.THUMBNAILS)[0].items,
    title: name,
    type,
    taxAmount,
});
